import React, { useEffect, useState } from "react";

// custom component
import AudioCard from "../../../components/audio/homepage/Card/Card";
// import AuthorCard from "../../../components/audio/homepage/AuthorCard/AuthorCard";
import SliderComponent from "../../../components/SliderComponent";

// loading state
// import Loading from "../../../components/loading";
import HomePageSkeleton from "../../../components/skeletonLoading/HomePageSkeleton";

import FlatList from "../../../components/FlatList";

// custom context
import { useNavbar } from "../../../context/NavBarContext";

import { NotFound } from "../../error/NotFound_404";

import {
  useFetchAudioHomeDataQuery,
} from "../../../api/audioHomePageApi";
import PaginatedBookGrid from "../../../components/audio/homepage/PaginatedBookGrid";
import { useSlider } from "../../../context/SliderContext";

const Index = () => {
  const Navbar = useNavbar();

  useEffect(() => {
    Navbar.reset();
  }, []);

  const { data, error, isLoading, isFetching } = useFetchAudioHomeDataQuery();
  const [modifiedData, setModifiedData] = useState();

  const { sliderData, sliderLoading } = useSlider();

  useEffect(() => {
    if (data) {
      let copyData = [...data.result];
      
      // Original logic: move first and last elements
      // const firstElement = copyData.shift();
      // const lastElement = copyData.pop();
      // let modifiedDataArray = [...copyData, firstElement, lastElement];
      
      // // Move PREMIUM BOOK to beginning if it exists
      // const premiumIndex = modifiedDataArray.findIndex(item => item.category_id === '8888'); //PREMIUM BOOK
      // if (premiumIndex > -1) {
      //   const premiumBook = modifiedDataArray.splice(premiumIndex, 1)[0];
      //   modifiedDataArray.unshift(premiumBook);
      // }
      
      // Add slider as the first item if slider data exists
      if (!sliderLoading && sliderData && sliderData.length > 0) {
        copyData.unshift({ //modifiedDataArray
          id: 'slider',
          category_id: 'slider',
          type: 'slider',
          data: sliderData,
        });
      }
      
      setModifiedData(copyData); //modifiedDataArray
    }
  }, [data, sliderData, sliderLoading]);

  if (isLoading) {
    return <HomePageSkeleton />;
  }
  
  if (error) {
    return <NotFound error={error} />
  }

  return (
    <div style={{ overflowX: 'hidden' }}>
      {modifiedData && (
        <FlatList
          data={modifiedData}
          scrollEnabled={false}
          renderItem={(item, index) => {
            switch (item.category_id) {
              case 'slider':
                return (
                  <SliderComponent 
                    key={index}
                    sliderData={item.data} 
                  />
                );
              // case 0:
              //   return (
              //     <AuthorCard 
              //       key={index} 
              //       data={item.items} 
              //       title={item.category} 
              //       category_id={item.category_id} 
              //       category_type={item.category_type} 
              //     />
              //   );
              default:
                return (
                  <AudioCard 
                    key={index} 
                    data={item.items} // Changed back to item.books
                    title={item.category} 
                    category_id={item.category_id} 
                    category_type={item.category_type} 
                  />
                );
            }
          }}
        />
      )}
      <PaginatedBookGrid />
    </div>
  );
};

export default Index;